// @ts-nocheck
import type { Question } from '../types';

export const technologySafetyQuestions: Question[] = [
  {
    id: 'q-ts-1',
    topic: 'General',
    question: 'What does ABS (Anti-lock Braking System) do?',
    options: [
      { id: 'q-ts-1o1', text: 'Prevents the wheels from locking during braking' },
      { id: 'q-ts-1o2', text: 'Automatically applies the brakes' },
      { id: 'q-ts-1o3', text: 'Increases braking distance' },
      { id: 'q-ts-1o4', text: 'Reduces fuel consumption' }
    ],
    answerId: 'q-ts-1o1',
    explanation: 'ABS (Anti-lock Braking System) prevents the wheels from locking during hard braking, allowing the driver to maintain steering control and reduce stopping distance.',
    subject: 'Technology & Safety'
  },
  {
    id: 'q-ts-2',
    topic: 'General',
    question: 'What does ESP (Electronic Stability Program) do?',
    options: [
      { id: 'q-ts-2o1', text: 'Controls the engine speed' },
      { id: 'q-ts-2o2', text: 'Helps maintain vehicle stability during cornering' },
      { id: 'q-ts-2o3', text: 'Controls the air conditioning' },
      { id: 'q-ts-2o4', text: 'Manages the fuel injection' }
    ],
    answerId: 'q-ts-2o2',
    explanation: 'ESP (Electronic Stability Program) helps maintain vehicle stability during cornering by automatically applying brakes to individual wheels when it detects loss of control.',
    subject: 'Technology & Safety'
  },
  {
    id: 'q-ts-3',
    topic: 'General',
    question: 'What is a rear-view camera used for?',
    options: [
      { id: 'q-ts-3o1', text: 'To watch movies while driving' },
      { id: 'q-ts-3o2', text: 'To help with reversing and parking' },
      { id: 'q-ts-3o3', text: 'To monitor traffic behind' },
      { id: 'q-ts-3o4', text: 'To take photos while driving' }
    ],
    answerId: 'q-ts-3o2',
    explanation: 'A rear-view camera helps with reversing and parking by providing a clear view of the area behind the vehicle, reducing blind spots.',
    subject: 'Technology & Safety'
  },
  {
    id: 'q-ts-4',
    topic: 'General',
    question: 'What does Adaptive Cruise Control (ACC) do?',
    options: [
      { id: 'q-ts-4o1', text: 'Automatically steers the vehicle' },
      { id: 'q-ts-4o2', text: 'Maintains a safe distance from the vehicle ahead' },
      { id: 'q-ts-4o3', text: 'Automatically parks the vehicle' },
      { id: 'q-ts-4o4', text: 'Controls the radio volume' }
    ],
    answerId: 'q-ts-4o2',
    explanation: 'Adaptive Cruise Control (ACC) maintains a set speed while automatically adjusting to maintain a safe distance from the vehicle ahead.',
    subject: 'Technology & Safety'
  },
  {
    id: 'q-ts-5',
    topic: 'General',
    question: 'What does Lane Departure Warning (LDW) do?',
    options: [
      { id: 'q-ts-5o1', text: 'Automatically steers the vehicle back into the lane' },
      { id: 'q-ts-5o2', text: 'Warns the driver when the vehicle drifts out of the lane' },
      { id: 'q-ts-5o3', text: 'Changes lanes automatically' },
      { id: 'q-ts-5o4', text: 'Controls the turn signals' }
    ],
    answerId: 'q-ts-5o2',
    explanation: 'Lane Departure Warning (LDW) warns the driver when the vehicle drifts out of the lane without using the turn signal.',
    subject: 'Technology & Safety'
  },
  {
    id: 'q-ts-6',
    topic: 'General',
    question: 'What does Blind Spot Monitoring (BSM) do?',
    options: [
      { id: 'q-ts-6o1', text: 'Automatically changes lanes' },
      { id: 'q-ts-6o2', text: 'Warns of vehicles in the blind spot' },
      { id: 'q-ts-6o3', text: 'Controls the mirrors' },
      { id: 'q-ts-6o4', text: 'Adjusts the seat position' }
    ],
    answerId: 'q-ts-6o2',
    explanation: 'Blind Spot Monitoring (BSM) warns the driver of vehicles in the blind spot when changing lanes.',
    subject: 'Technology & Safety'
  },
  {
    id: 'q-ts-7',
    topic: 'General',
    question: 'What does Autonomous Emergency Braking (AEB) do?',
    options: [
      { id: 'q-ts-7o1', text: 'Automatically applies brakes to prevent collisions' },
      { id: 'q-ts-7o2', text: 'Controls the steering wheel' },
      { id: 'q-ts-7o3', text: 'Manages the fuel system' },
      { id: 'q-ts-7o4', text: 'Adjusts the suspension' }
    ],
    answerId: 'q-ts-7o1',
    explanation: 'Autonomous Emergency Braking (AEB) automatically applies the brakes to prevent or reduce the severity of a collision when it detects an imminent crash.',
    subject: 'Technology & Safety'
  },
  {
    id: 'q-ts-8',
    topic: 'General',
    question: 'What does Tire Pressure Monitoring System (TPMS) do?',
    options: [
      { id: 'q-ts-8o1', text: 'Automatically inflates the tires' },
      { id: 'q-ts-8o2', text: 'Warns of low tire pressure' },
      { id: 'q-ts-8o3', text: 'Changes the tires automatically' },
      { id: 'q-ts-8o4', text: 'Controls the suspension' }
    ],
    answerId: 'q-ts-8o2',
    explanation: 'Tire Pressure Monitoring System (TPMS) warns the driver when tire pressure is too low, which can affect safety and fuel efficiency.',
    subject: 'Technology & Safety'
  },
  {
    id: 'q-ts-9',
    topic: 'General',
    question: 'What should you do when using cruise control on a wet or slippery road?',
    options: [
      { id: 'q-ts-9o1', text: 'Increase the set speed for better control' },
      { id: 'q-ts-9o2', text: 'Switch off cruise control and drive manually' },
      { id: 'q-ts-9o3', text: 'Keep cruise control on; it improves grip' }
    ],
    answerId: 'q-ts-9o2',
    explanation: 'On wet or slippery roads, you should switch off cruise control and drive manually. Cruise control can reduce your ability to respond quickly to changing conditions.',
    subject: 'Technology & Safety'
  },
  {
    id: 'q-ts-10',
    topic: 'General',
    question: 'What should you do when the ABS warning light stays on while driving?',
    options: [
      { id: 'q-ts-10o1', text: 'Continue driving; ABS is optional' },
      { id: 'q-ts-10o2', text: 'Have the ABS system checked as soon as possible' },
      { id: 'q-ts-10o3', text: 'Drive faster to reset the system' }
    ],
    answerId: 'q-ts-10o2',
    explanation: 'If the ABS warning light stays on, the anti-lock braking system may not work. Have it checked by a qualified mechanic as soon as possible. Normal braking still works but without ABS assistance.',
    subject: 'Technology & Safety'
  },
  {
    id: 'q-ts-11',
    topic: 'General',
    question: 'What does a blind spot detection system typically warn you about?',
    options: [
      { id: 'q-ts-11o1', text: 'Vehicles directly in front of you' },
      { id: 'q-ts-11o2', text: 'Vehicles in the area beside and behind your car that you may not see in the mirrors' },
      { id: 'q-ts-11o3', text: 'Pedestrians on the pavement' }
    ],
    answerId: 'q-ts-11o2',
    explanation: 'Blind spot detection warns of vehicles in the area beside and behind your car that may not be visible in the mirrors. Always still look over your shoulder before changing lanes.',
    subject: 'Technology & Safety'
  },
  {
    id: 'q-ts-12',
    topic: 'General',
    question: 'What does Lane Keep Assist (LKA) do?',
    options: [
      { id: 'q-ts-12o1', text: 'Warns you when you drift out of your lane' },
      { id: 'q-ts-12o2', text: 'Gently steers the car back into the lane if you drift without indicating' },
      { id: 'q-ts-12o3', text: 'Automatically changes lanes for you' }
    ],
    answerId: 'q-ts-12o2',
    explanation: 'Lane Keep Assist (LKA) gently applies steering correction to help keep the vehicle in the lane when it detects unintentional lane departure without use of the indicator.',
    subject: 'Technology & Safety'
  },
  {
    id: 'q-ts-13',
    topic: 'General',
    question: 'What does a red warning light on the dashboard usually indicate?',
    options: [
      { id: 'q-ts-13o1', text: 'A minor issue; you can continue your journey' },
      { id: 'q-ts-13o2', text: 'A serious problem; stop as soon as it is safe and check the vehicle' },
      { id: 'q-ts-13o3', text: 'The system is working correctly' }
    ],
    answerId: 'q-ts-13o2',
    explanation: 'A red warning light usually indicates a serious problem that requires immediate attention. Stop as soon as it is safe to do so and check the vehicle before continuing.',
    subject: 'Technology & Safety'
  }
];
